/**
 * Email domains permitted to sign in.
 *
 * This list drives a client-side check only. It exists so someone signing in
 * with a personal Google account gets an immediate, plain answer instead of a
 * role error from the backend that reads like a bug.
 *
 * It is NOT a security boundary: by the time it runs the user already holds a
 * valid Firebase token, and anything enforced in this bundle can be bypassed.
 * Access is really gated by the backend on GET /users/api/v1. See
 * docs/auth-domain-restriction.md.
 */
export const ALLOWED_EMAIL_DOMAINS = ['skyri.se', 'taptapdigital.com'] as const;

/**
 * Exact-domain match on the part after the last "@", lowercased.
 *
 * Deliberately not a suffix match: "endsWith('skyri.se')" would also accept
 * "notskyri.se" and "evil-skyri.se", so the domain has to be equal.
 */
export const isAllowedEmailDomain = (email?: string | null): boolean => {
  if (!email) return false;
  const domain = email.trim().toLowerCase().split('@').pop();
  if (!domain) return false;
  return ALLOWED_EMAIL_DOMAINS.some((allowed) => domain === allowed);
};
